const AboutPage = () => {
  return <></>;
};

export default AboutPage;
